// extracted by mini-css-extract-plugin
export default {"wrapper":"VE-z","button":"WE-z","alternate":"XE-z","disabled":"YE-z","paymentWarning":"ZE-z","fadeIn":"_E-z"};